module.exports = __webpack_public_path__ + "static/media/cryptomonedas.96e45d69.png";